import { __makeTemplateObject, __assign } from 'tslib';
import React__default from 'react';
import { ToastContainer as ToastContainer$1 } from '../../../node_modules/react-toastify/dist/react-toastify.esm.js';
import styled from 'styled-components';

var StyledToastContainer = /*#__PURE__*/styled(ToastContainer$1).withConfig({
  displayName: "ToastContainer__StyledToastContainer",
  componentId: "sc-c6qx5s-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .Toastify__toast--error {\n    background-color: ", ";\n  }\n  .Toastify__toast--warning {\n    background-color: ", ";\n  }\n  .Toastify__toast--success {\n    background-color: ", ";\n  }\n  .Toastify__toast--info {\n    background-color: ", ";\n  }\n"], ["\n  .Toastify__toast--error {\n    background-color: ", ";\n  }\n  .Toastify__toast--warning {\n    background-color: ", ";\n  }\n  .Toastify__toast--success {\n    background-color: ", ";\n  }\n  .Toastify__toast--info {\n    background-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.redRedWine;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.charlie;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.papaSmurf;
});
var ToastContainer = function (props) {
  return React__default.createElement(StyledToastContainer, __assign({
    position: "top-right",
    hideProgressBar: true
  }, props));
};
var templateObject_1;

export { ToastContainer };
//# sourceMappingURL=ToastContainer.js.map
